





















































































































import { IPRCSet, RateChangesState } from "@/models";
import AuthModule from "@storage360/login/src/store/modules/auth";
import RateChangesModule from "@/store/modules/rate-changes";
import { Component, Vue } from "vue-property-decorator";
import { changeSetHeaders } from "@/helpers/iprc/change-sets-headers";
import { namespace, State } from "vuex-class";
import moment from "moment";
import { approvalRoles } from "@/helpers/iprc/approval-roles";

const auth = namespace(AuthModule.name);
const rateChanges = namespace(RateChangesModule.name);

@Component({
  name: "ChangeSetsTable"
})
export default class ChangeSetsTable extends Vue {
  // ===== Store ===== //
  @auth.Getter("allowedAccess") private allowedAccess!: string[];
  @State("rateChanges") private readonly rateChanges!: RateChangesState;
  @rateChanges.Action("deleteIPRCSet") private deleteIPRCSet!: (id: number) => void;
  @rateChanges.Action("getInlinePriceChange") private getInlinePriceChange!: (id: number) => void;
  @rateChanges.Action("getIPRCSets") private getIPRCSets!: () => void;
  @rateChanges.Action("revertIPRCSet") private revertIPRCSet!: (id: number) => void;
  @rateChanges.Action("loadIPRCSet") private loadIPRCSet!: (id: number) => void;
  @rateChanges.Action("reviewIPRCSetPriceChanges") private reviewIPRCSetPriceChanges!: (id: number) => void;
  @rateChanges.Action("setSelectedTab") private setSelectedTab!: (selectedTab: number) => void;
  // ===== Data ===== //
  private headers = changeSetHeaders;
  private revertConfirmModal = false;
  private selectedIPRCSetId = 0;
  private selectedIPRCSetEffectiveDate = "";
  // ===== Methods ===== //
  private toEdit(item: IPRCSet): void {
    this.loadIPRCSet(item.id);
    this.getInlinePriceChange(item.id);
    this.$router.push({
      name: "rateChange",
      params: {
        id: String(item.id)
      }
    });
    this.setSelectedTab(1);
  }
  private viewButtonText(setStatus: string): string {
    const showViewStatuses = [
      "error processing reverted price changes",
      "error processing price updates",
      "prices updated",
      "reverted prices back to original rates"
    ];
    return showViewStatuses.includes(setStatus.toLowerCase()) ? "View" : "Review";
  }
  private displayEditAndDelete(item: IPRCSet): boolean {
    const status = item.status.toLowerCase();
    return !status.includes("prices update") &&
      !status.includes("queued") &&
      !status.includes("revert") &&
      !status.includes("unable to process") &&
      !status.includes("error processing");
  }
  private displayRevert(item: IPRCSet): boolean {
    return this.isRevManagerApprover &&
      moment.utc(item.effectiveDate).isAfter(moment.utc().format("MM/DD/YYYY")) &&
      item.status.toLowerCase().includes("prices updated");
  }
  private toRevert(item: IPRCSet): void {
    this.selectedIPRCSetId = item.id;
    this.selectedIPRCSetEffectiveDate = moment.utc(item.effectiveDate).format("dddd, MMMM Do, YYYY");
    this.revertConfirmModal = true;
  }
  private confirmRevertPriceChange(): void {
    this.revertIPRCSet(this.selectedIPRCSetId);
    this.closeRevertConfirmModal();
  }
  private closeRevertConfirmModal(): void {
    this.revertConfirmModal = false;
    this.selectedIPRCSetId = 0;
    this.selectedIPRCSetEffectiveDate = "";
  }
  private toReview(id: number): void {
    this.loadIPRCSet(id);
    this.reviewIPRCSetPriceChanges(id);
    this.$router.push({
      name: "confirmChange"
    });
  }
  private refreshChangeSetsTable() {
    this.getIPRCSets();
  }
  // ===== Computed ===== //
  get isRevManagerApprover(): boolean {
    return approvalRoles.some(role => this.allowedAccess.includes(role));
  }
}
